import { Button } from "@/components/ui/button";
import { WavyBackground } from "@/components/ui/wavy-background";
import { ArrowDown } from "lucide-react";
import Link from "next/link";
import { LogoSection } from "./company-logo-section";

type ScrollDownActionType =
    | "split-payments"
    | "co-ownership-campaigns"
    | "content-marketplace"
    | "blockchain-payouts"
    | "start-exploring";

export function HeroSectionV2({ onScrollDownAction }: { onScrollDownAction: (type: ScrollDownActionType) => void }) {
    return (
        <>
            <WavyBackground className="relative mx-auto">
                <div className="mx-4 flex flex-col items-center">
                    <div className="max-w-2xl text-balance text-center font-bold text-4xl leading-tight md:text-5xl">
                        Real-Time YouTube & Instant TikTok <span className="text-accent-flashy">Payouts</span>
                    </div>
                    <div className="mt-3 max-w-md text-balance text-center text-muted-foreground ">
                        The Payout Software That Powers the Creative Industry. Access Your YouTube AdSense in Real-Time.
                        Never Wait for the 21st of the Month to Get Paid.
                    </div>

                    <div className="mt-6 flex flex-wrap justify-center gap-2 text-xs">
                        <Button variant="default" asChild>
                            <Link
                                href="https://talentir-com.pipedrive.com/scheduler/BplO81F0/keep-more-get-paid-faster-take-full-control-of-your-revenue"
                                target="_blank"
                            >
                                Book Call
                            </Link>
                        </Button>
                    </div>
                </div>
            </WavyBackground>
            <div className="absolute right-0 bottom-0 left-0 flex h-screen flex-col items-center justify-end">
                <div className="absolute mb-4 flex h-2/5 items-end justify-between md:items-center">
                    <LogoSection />
                </div>
                <div className="mb-4 hidden flex-col items-center md:flex">
                    <Button
                        className="animate-bounce rounded-full"
                        size="icon"
                        onClick={() => {
                            onScrollDownAction("start-exploring");
                        }}
                        variant="outline"
                    >
                        <ArrowDown />
                    </Button>
                    <p className="mt-2 font-bold text-muted-foreground text-sm uppercase">Start Exploring</p>
                </div>
            </div>
        </>
    );
}
